const purple = {
    100: 'rgb(183, 186, 225)',
    200: 'rgb(154, 158, 213)',
    300: 'rgb(126, 131, 201)',
    400: 'rgb(97, 103, 189)',
    500: 'rgb(72, 79, 173)',
    600: 'rgb(60, 66, 144)',
    700: 'rgb(48, 53, 115)',
    800: 'rgb(36, 39, 86)',
};
export default purple;
